import Image from 'next/image';

const animations = `
  @keyframes expandCollapse {
    0%, 100% {
      width: 100%;
    }
    50% {
      width: 0%;
    }
  }
  
  @keyframes textMove {
    0%, 100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(-80px);
    }
  }
  
  @media (min-width: 1024px) {
    .animate-image-expand {
      animation: expandCollapse 15s ease-in-out infinite;
    }
    
    .animate-text-move {
      animation: textMove ease-in-out infinite;
    }
  }
`;

const OurMission = () => {
  return (
    <div className="w-full relative overflow-hidden flex flex-col items-start py-8 md:py-[38px] px-4 md:px-12 lg:px-24 xl:px-[142px] box-border text-left text-base text-[#3a599c] font-roboto">
      <style>{animations}</style>
      <div className="self-stretch flex items-start justify-center">
        <div className="w-full max-w-[1634px] flex flex-col lg:flex-row items-center lg:items-start gap-6 md:gap-8">
          <div className="overflow-hidden w-full lg:w-auto animate-image-expand lg:max-w-[550px] xl:max-w-[600px] 2xl:max-w-[660px]">
            <Image 
              src="/images/cms-pages/a1.png" 
              alt="Team collaboration" 
              width={700}
              height={378}
              className="w-full h-auto lg:h-[300px] lg:w-[550px] xl:h-[340px] xl:w-[600px] 2xl:h-[378px] 2xl:w-[660px] relative rounded-[32px] object-cover" 
            />
          </div>
          <div className="hidden lg:flex h-[90px] w-[60px] xl:h-[100px] xl:w-[70px] 2xl:h-[113px] 2xl:w-[77px] flex-col items-start" />
          <div className="flex flex-col items-start gap-2 w-full lg:w-auto animate-text-move lg:max-w-[550px] xl:max-w-[650px] 2xl:max-w-[800px]">
            <div className="w-full flex flex-col items-start">
              <div className="self-stretch relative leading-6 font-semibold text-sm md:text-base">Our mission</div>
            </div>
            <div className="w-full flex flex-col items-start gap-4 md:gap-8 text-xl lg:text-xl xl:text-[26px] 2xl:text-[32px] text-black">
              <div className="w-full relative leading-6 lg:leading-7 xl:leading-8 2xl:leading-9 inline-block">
                <span>{`Our `}</span>
                <span className="text-[#3a599c]">mission</span>
                <span> is to empower every skilled individual  from students to professionals to turn their talent into opportunity and independence. Hyrelancer exists to uplift incomes, celebrate human connection, and redefine freelancing for a stronger, self-reliant India.</span>
              </div>
              {/* <div className="w-full max-w-[657px] relative text-sm md:text-base leading-6 inline-block">At Hyrelancer, we don't just connect people. We create possibilities.</div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMission;